/* Sainly collection filters: colour, style, occasion, price + sort (Oct 2026) */
(function () {
  'use strict';
  var root = document.getElementById('smf-colf');
  var grid = document.querySelector('.shop-product-wrap');
  if (!root || !grid) return;
  var BASE = root.getAttribute('data-url');
  var MONEY = root.getAttribute('data-money') || '${{amount}}';

  var COLOURS = [
    ['Black', '#111', /\bblack\b|\bcharcoal\b/],
    ['White & Ivory', '#f7f5ef', /\bwhite\b|\bivory\b|\boff[- ]white\b/],
    ['Cream & Beige', '#e8dcc4', /\bcream\b|\bbeige\b|\bkhaki\b|\bcamel\b|\btan\b|\bsand\b/],
    ['Brown', '#6b4a2f', /\bbrown\b|\bcoffee\b|\bchocolate\b|\bbronze\b/],
    ['Grey', '#8a8d91', /\bgr[ae]y\b/],
    ['Navy', '#1f2a44', /\bnavy\b/],
    ['Blue', '#3b6fb6', /\bblue\b|\bteal\b|\bturquoise\b/],
    ['Green', '#3f6b4a', /\bgreen\b|\bsage\b|\bolive\b|\bemerald\b|\bmint\b/],
    ['Red & Burgundy', '#8c1d2c', /\bred\b|\bburgundy\b|\bmaroon\b|\bwine\b/],
    ['Pink & Peach', '#f0b8b0', /\bpink\b|\bpeach\b|\bblush\b|\brose\b/],
    ['Purple', '#6b4a8a', /\bpurple\b|\blavender\b|\blilac\b|\bviolet\b|\bplum\b/],
    ['Yellow & Mustard', '#d9a92b', /\byellow\b|\bmustard\b/],
    ['Orange & Rust', '#c0612b', /\borange\b|\brust\b/],
    ['Gold & Silver', '#c8b07a', /\bgold(en)?\b|\bsilver\b/],
    ['Multicolour', 'linear-gradient(135deg,#c0262d,#f2d03b,#3f6b4a,#3b6fb6)', /multi[- ]?colou?r/]
  ];
  var STYLES = [
    ['3 Piece Suit', /three[- ]piece|3[- ]piece/],
    ['2 Piece Suit', /two[- ]piece|2[- ]piece/],
    ['Double Breasted', /double[- ]breasted/],
    ['Jodhpuri & Nehru', /jodhpuri|bandhgala|nehru|modi jacket/],
    ['Blazer & Jacket', /blazer|jacket/],
    ['Waistcoat', /waistcoat|waist coat|\bvest\b/],
    ['Overcoat & Trench', /overcoat|over coat|trench|long coat|\bcoat\b/],
    ['Trousers', /\bpants?\b|trouser/],
    ['Shirt', /\bshirts?\b/],
    ['Kimono & Robe', /kimono|robe/],
    ['Dress', /\bdress\b(?! (pant|shirt|trouser))/]
  ];
  var TYPES = [
    ['Tuxedo', /tuxedo|smoking/],
    ['Double Breasted', /double[- ]breasted/],
    ['Single Breasted', /single[- ]breasted/],
    ['1 Button', /\b(one|1)[- ]button/],
    ['2 Button', /\b(two|2)[- ]button/],
    ['Peak Lapel', /peak(ed)? lapel/],
    ['Shawl Lapel', /shawl/],
    ['Notch Lapel', /notch/],
    ['Velvet', /velvet/],
    ['Linen', /linen/],
    ['Tweed', /tweed|herringbone/],
    ['Checked', /\bcheck(ed|s)?\b|plaid|tartan|windowpane/],
    ['Pinstripe', /pin[- ]?stripe|striped/],
    ['Embroidered', /embroider/],
    ['Printed & Floral', /floral|printed|\bprint\b/],
    ['Jodhpuri & Bandhgala', /jodhpuri|bandhgala/],
    ['Indo-Western', /indo[- ]western|sherwani|kurta/],
    ['Double Breasted Waistcoat', /double[- ]breasted (waistcoat|vest)/]
  ];
  var LOOKS = [['Same Colour (Matching)'], ['Contrast / Mix & Match']];
  /* Product metafield values (custom.colour / look / occasion / style / design_type) */
  var SHADES = [["Black","#111","Black"],["Charcoal","#36454f","Black"],["White","#ffffff","White & Ivory"],["Off White","#f5f2e8","White & Ivory"],["Ivory","#fffff0","White & Ivory"],["Cream","#f3e9d2","Cream & Beige"],["Beige","#e2d3b5","Cream & Beige"],["Khaki","#c3b091","Cream & Beige"],["Camel","#c19a6b","Cream & Beige"],["Tan","#d2b48c","Cream & Beige"],["Sand","#d8c69e","Cream & Beige"],["Champagne","#f1ddc0","Cream & Beige"],["Brown","#6b4a2f","Brown"],["Dark Brown","#4a3020","Brown"],["Coffee Brown","#6f4e37","Brown"],["Golden Brown","#996515","Brown"],["Chocolate Brown","#4e2a1e","Brown"],["Copper","#b87333","Brown"],["Grey","#8a8d91","Grey"],["Light Grey","#c8c9cc","Grey"],["Dark Grey","#55585c","Grey"],["Navy Blue","#1f2a44","Navy"],["Blue","#3b6fb6","Blue"],["Royal Blue","#2b4fc4","Blue"],["Sky Blue","#87ceeb","Blue"],["Light Blue","#add8e6","Blue"],["Powder Blue","#b0d0e6","Blue"],["Cobalt Blue","#0047ab","Blue"],["Teal Blue","#367588","Blue"],["Turquoise","#40c0c0","Blue"],["Green","#3f6b4a","Green"],["Sage Green","#9caf88","Green"],["Olive Green","#6b7a3a","Green"],["Dark Olive Green","#556b2f","Green"],["Emerald Green","#1f8a5b","Green"],["Forest Green","#228b22","Green"],["Pine Green","#01796f","Green"],["Hunter Green","#355e3b","Green"],["Bottle Green","#006a4e","Green"],["Dark Green","#1e4d2b","Green"],["Light Green","#90c290","Green"],["Mint Green","#a8e6c1","Green"],["Pista Green","#93c572","Green"],["Teal Green","#00827f","Green"],["Red","#c0262d","Red & Burgundy"],["Maroon","#6d1a26","Red & Burgundy"],["Burgundy","#800020","Red & Burgundy"],["Wine","#722f37","Red & Burgundy"],["Pink","#f0a5b8","Pink & Peach"],["Light Pink","#f8cdd6","Pink & Peach"],["Dusty Rose","#c98b8b","Pink & Peach"],["Blush","#f2c4c0","Pink & Peach"],["Peach","#f6c3a3","Pink & Peach"],["Coral","#f0806a","Pink & Peach"],["Purple","#6b4a8a","Purple"],["Dark Purple","#3e2659","Purple"],["Light Purple","#b9a2d6","Purple"],["Lavender","#c6b6e0","Purple"],["Lilac","#c8a2c8","Purple"],["Plum","#6e3a5e","Purple"],["Yellow","#f2d03b","Yellow & Mustard"],["Mustard","#d9a92b","Yellow & Mustard"],["Orange","#e67e22","Orange & Rust"],["Burnt Orange","#cc5500","Orange & Rust"],["Rust","#b7410e","Orange & Rust"],["Gold","#c8a24a","Gold & Silver"],["Silver","#c0c0c0","Gold & Silver"],["Multicolour","linear-gradient(135deg,#c0262d,#f2d03b,#3f6b4a,#3b6fb6)","Multicolour"]];
  var SFAM = {}; SHADES.forEach(function (x) { SFAM[x[0]] = x[2]; });
  var STYLE_ORDER = ["3 Piece Suit","2 Piece Suit","Jodhpuri Suit","Bandhgala","Indo-Western","Blazer","Smoking Jacket","Shacket","Waistcoat","Waistcoat & Pant Set","Half Jacket","Overcoat","Trench Coat","Long Coat","Tailcoat","Trousers","Gurkha Pant","Bootcut Trousers","Shirt","Shirt & Pant Set","Kimono","Robe","Women's Pant Suit","Women's 3 Piece Suit","Women's Blazer","Women's Trousers","Women's Long Coat","Women's Dress","Women's Co-ord Set","Boys Suit","Boys Jacket","Boys Outfit","Bow Tie","Tie","Brooch","Pocket Square"];
  var OCC_ORDER = ["Wedding","Groom","Groomsmen","Best Man","Engagement","Reception","Sangeet & Mehndi","Party","Cocktail Party","Dinner","Prom","Black Tie & Gala","Formal & Office","Festive","Christmas","Beach Wedding","Destination Wedding","Casual","Summer","Winter"];
  var TYPE_ORDER = ["Tuxedo","Single Breasted","Double Breasted","1 Button","2 Button","3 Button","Peak Lapel","Notch Lapel","Shawl Lapel","Mandarin Collar","Contrast Lapel","Velvet","Linen","Tweed","Wool Blend","Satin","Jacquard","Corduroy","Embroidered","Printed & Floral","Checked","Pinstripe","Herringbone","Double Breasted Waistcoat","Belted"];
  var LMF = { 'Matching': 'Same Colour (Matching)', 'Contrast': 'Contrast / Mix & Match' };
  var CW = 'black|white|ivory|cream|beige|khaki|brown|grey|gray|navy|blue|teal|green|sage|olive|emerald|red|maroon|burgundy|wine|purple|pink|peach|yellow|mustard|gold|golden|silver|orange|rust|lavender|lilac|charcoal|tan|champagne|turquoise|aqua|mint|coral|magenta|violet';
  var PAIR = new RegExp('\\b(' + CW + ')\\b(\\s+[a-z]+)?\\s+(and|&|\\/)\\s+([a-z]+\\s+)?(' + CW + ')\\b');
  var OCCASIONS = [
    ['Wedding', /wedding|groom\b|grooms\b|bridal|marriage/],
    ['Groomsmen', /groomsm[ae]n/],
    ['Engagement', /engagement/],
    ['Reception', /reception/],
    ['Party', /\bpart(y|ies)\b|cocktail|evening|gala/],
    ['Dinner', /dinner/],
    ['Prom', /\bprom\b/],
    ['Formal & Office', /office|business|formal|corporate/],
    ['Festive', /festive|festival|christmas|diwali/],
    ['Beach Wedding', /beach|destination|summer/],
    ['Casual', /casual/],
    ['Winter', /winter|tweed|velvet|wool|overcoat/]
  ];
  var PRICES = [
    ['Under $100', 0, 10000],
    ['$100 – $200', 10000, 20000],
    ['$200 – $300', 20000, 30000],
    ['$300 and above', 30000, 1e12]
  ];

  var items = [], sel = { t: {}, l: {}, c: {}, h: {}, s: {}, o: {}, p: {} }, sort = 'featured', shown = 24, loaded = false;
  var origHTML = grid.innerHTML;
  var pag = document.querySelector('.pagination');
  var pagWrap = pag ? (pag.closest('.row') || pag) : null;

  function money(c) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(c, MONEY); } catch (e) {}
    return '$' + (c / 100).toFixed(2);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function tag(it) {
    var txt = (it.t + ' ' + it.ty).toLowerCase();
    var styleTxt = txt;
    it.f = { t: {}, l: {}, c: {}, h: {}, s: {}, o: {}, p: {} };
    COLOURS.forEach(function (c) { if (c[2].test(txt)) it.f.c[c[0]] = 1; });
    TYPES.forEach(function (x) { if (x[1].test(it.t.toLowerCase())) it.f.t[x[0]] = 1; });
    var tl = it.t.toLowerCase(), tgl = String(it.tg || '').toLowerCase();
    if (/suit|tuxedo|piece/.test(tl)) {
      if (/contrast|two[- ]tone|mix (and|&) match/.test(tl + ' ' + tgl) || PAIR.test(tl)) it.f.l['Contrast / Mix & Match'] = 1;
      else if (Object.keys(it.f.c).length === 1) it.f.l['Same Colour (Matching)'] = 1;
    }
    var isSuit = /suit/.test(styleTxt);
    STYLES.forEach(function (s) {
      if (!s[1].test(styleTxt)) return;
      if (isSuit && (s[0] === 'Blazer & Jacket' || s[0] === 'Trousers' || s[0] === 'Waistcoat' || s[0] === 'Shirt' || s[0] === 'Overcoat & Trench' || s[0] === 'Dress') && /piece|suit/.test(styleTxt) && !/jacket only|blazer only/.test(styleTxt)) {
        if (/three[- ]piece|3[- ]piece|two[- ]piece|2[- ]piece/.test(styleTxt)) return;
      }
      it.f.s[s[0]] = 1;
    });
    OCCASIONS.forEach(function (o) { if (o[1].test(txt + ' ' + (it.tg || '').toLowerCase())) it.f.o[o[0]] = 1; });
    PRICES.forEach(function (p) { if (it.p >= p[1] && it.p < p[2]) it.f.p[p[0]] = 1; });
    if (it.ft) {
      var CMAP = { 'Red & Maroon': 'Red & Burgundy', 'Yellow & Gold': 'Yellow & Mustard', 'Orange': 'Orange & Rust' };
      var LMAP = { 'Matching': 'Same Colour (Matching)', 'Contrast': 'Contrast / Mix & Match' };
      var T = { colour: [], look: [], occasion: [], type: [], style: [] };
      it.ft.split('|').forEach(function (x) { var k = x.indexOf(':'); if (k < 1) return; var n = x.slice(0, k).trim().toLowerCase(), v = x.slice(k + 1).trim(); if (T[n] && v) T[n].push(v); });
      if (T.colour.length) { it.f.c = {}; T.colour.forEach(function (v) { it.f.c[CMAP[v] || v] = 1; }); }
      if (T.look.length) { it.f.l = {}; T.look.forEach(function (v) { it.f.l[LMAP[v] || v] = 1; }); }
      if (T.occasion.length) { it.f.o = {}; T.occasion.forEach(function (v) { it.f.o[v] = 1; }); }
      T.type.forEach(function (v) { it.f.t[v] = 1; });
      T.style.forEach(function (v) { it.f.s[v] = 1; });
    }
    var m = it.m;
    if (m && m.s && m.s.length) {
      it.f.s = {}; m.s.forEach(function (v) { it.f.s[v] = 1; });
      it.f.c = {}; it.f.h = {}; (m.c || []).forEach(function (v) { it.f.h[v] = 1; if (SFAM[v]) it.f.c[SFAM[v]] = 1; });
      it.f.l = {}; if (m.l) it.f.l[LMF[m.l] || m.l] = 1;
      it.f.o = {}; (m.o || []).forEach(function (v) { it.f.o[v] = 1; });
      it.f.t = {}; (m.y || []).forEach(function (v) { it.f.t[v] = 1; });
    }
  }
  function active(g) { return Object.keys(sel[g]).length > 0; }
  function anyActive() { return active('t') || active('l') || active('c') || active('h') || active('s') || active('o') || active('p'); }
  function match(it, skip) {
    for (var g in sel) {
      if (g === skip || !active(g)) continue;
      var ok = false;
      for (var v in sel[g]) if (it.f[g][v]) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  }
  function results() {
    var r = items.filter(function (it) { return match(it); });
    if (sort === 'price-asc') r.sort(function (a, b) { return a.p - b.p; });
    else if (sort === 'price-desc') r.sort(function (a, b) { return b.p - a.p; });
    else if (sort === 'newest') r.sort(function (a, b) { return b.d - a.d; });
    return r;
  }
  function counts(g, list) {
    var out = {};
    items.forEach(function (it) { if (!match(it, g)) return; for (var v in it.f[g]) out[v] = (out[v] || 0) + 1; });
    return out;
  }

  var GROUPS = [
    ['c', 'Colour', COLOURS.map(function (c) { return c[0]; })],
    ['h', 'Shade', SHADES.map(function (x) { return x[0]; })],
    ['l', 'Suit Look', LOOKS.map(function (x) { return x[0]; })],
    ['t', 'Type', TYPE_ORDER.slice()],
    ['s', 'Style', STYLE_ORDER.slice()],
    ['o', 'Occasion', OCC_ORDER.slice()],
    ['p', 'Price', PRICES.map(function (p) { return p[0]; })]
  ];
  function swatch(v) { for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i][0] === v) return COLOURS[i][1]; for (var k = 0; k < SHADES.length; k++) if (SHADES[k][0] === v) return SHADES[k][1]; return ''; }

  function panelHTML() {
    var h = '<div class="smf-f__head"><span class="smf-f__title">Filter &amp; Sort</span>' + (anyActive() ? '<button type="button" class="smf-f__clear" data-clear="1">Clear all</button>' : '') + '</div>';
    h += '<div class="smf-f__group"><label class="smf-f__gtitle" for="smf-sort">Sort by</label><select id="smf-sort" class="smf-f__sort">' +
      [['featured', 'Featured'], ['newest', 'Newest'], ['price-asc', 'Price: low to high'], ['price-desc', 'Price: high to low']].map(function (o) {
        return '<option value="' + o[0] + '"' + (sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
      }).join('') + '</select></div>';
    GROUPS.forEach(function (G) {
      if (G[0] === 'h' && !active('c') && !active('h')) return;
      var cnt = counts(G[0]);
      var vals = G[2].filter(function (v) { return cnt[v] || sel[G[0]][v]; });
      if (vals.length < 2 && !active(G[0])) return;
      h += '<details class="smf-f__group" open><summary class="smf-f__gtitle">' + G[1] + (active(G[0]) ? ' <span class="smf-f__n">(' + Object.keys(sel[G[0]]).length + ')</span>' : '') + '</summary><ul class="smf-f__list' + (G[0] === 'c' || G[0] === 'h' ? ' smf-f__list--sw' : '') + '">';
      vals.forEach(function (v) {
        var on = !!sel[G[0]][v];
        h += '<li><label class="smf-f__opt' + (on ? ' is-on' : '') + '"><input type="checkbox" data-g="' + G[0] + '" value="' + esc(v) + '"' + (on ? ' checked' : '') + '>' +
          (G[0] === 'c' || G[0] === 'h' ? '<span class="smf-f__sw" style="background:' + swatch(v) + '"></span>' : '') +
          '<span>' + esc(v) + '</span><span class="smf-f__cnt">' + (cnt[v] || 0) + '</span></label></li>';
      });
      h += '</ul></details>';
    });
    return h;
  }
  function card(it) {
    var off = it.cp > it.p ? Math.round((1 - it.p / it.cp) * 100) : 0;
    return '<div class="col-6 col-sm-6 col-lg-3 col-md-6"><div class="smf-card">' +
      '<a class="smf-card__img" href="' + esc(it.u) + '">' +
      (it.i ? '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" loading="lazy" width="500" height="750">' : '') +
      (it.i2 ? '<img class="smf-card__img2" src="' + esc(it.i2) + '" alt="" loading="lazy" width="500" height="750">' : '') +
      (off >= 5 ? '<span class="smf-card__badge">-' + off + '%</span>' : '') + '</a>' +
      '<h3 class="smf-card__t"><a href="' + esc(it.u) + '">' + esc(it.t) + '</a></h3>' +
      '<div class="smf-card__p"><span class="money">' + money(it.p) + '</span>' + (off >= 5 ? ' <s class="money">' + money(it.cp) + '</s>' : '') + '</div>' +
      '</div></div>';
  }
  var panels = [];
  function renderPanels() { var h = panelHTML(); panels.forEach(function (p) { p.innerHTML = h; }); updateBtn(); renderTypeChips(); }
  var tchips = document.querySelector('.smf-cchips');
  function chipsReady() { if (tchips) tchips.classList.add('is-ready'); }
  setTimeout(chipsReady, 15000);
  var NOUN = (function () {
    var h = ((document.querySelector('h1') || {}).textContent || '').toLowerCase();
    if (/three[- ]piece|3[- ]piece/.test(h)) return '3 Piece Suits';
    if (/two[- ]piece|2[- ]piece/.test(h)) return '2 Piece Suits';
    if (/tuxedo/.test(h)) return 'Tuxedos';
    if (/jodhpuri|bandhgala/.test(h)) return 'Jodhpuri Suits';
    if (/blazer/.test(h)) return 'Blazers';
    if (/waistcoat|vest/.test(h)) return 'Waistcoats';
    if (/overcoat|trench|coat/.test(h)) return 'Coats';
    if (/jacket/.test(h)) return 'Jackets';
    if (/pant|trouser/.test(h)) return 'Trousers';
    if (/shirt/.test(h)) return 'Shirts';
    if (/suit/.test(h)) return 'Suits';
    return '';
  })();
  function renderTypeChips() {
    if (!tchips || !loaded) return;
    var total = items.length, cnt = {};
    items.forEach(function (it) { for (var v in it.f.t) cnt[v] = (cnt[v] || 0) + 1; });
    var list = Object.keys(cnt).filter(function (v) { return (cnt[v] >= 2 && cnt[v] < total) || sel.t[v]; });
    list.sort(function (a, b) { return (cnt[b] || 0) - (cnt[a] || 0); });
    list = list.slice(0, 12);
    if (list.length < 2) { chipsReady(); return; }
    var none = !active('t');
    var h = '<li' + (none ? ' class="active"' : '') + '><button type="button" class="smf-tchip" data-t="">All ' + esc(NOUN || 'Products') + ' <span>' + total + '</span></button></li>';
    list.forEach(function (v) {
      var lab = NOUN && !(v === 'Tuxedo' && NOUN === 'Tuxedos') && !(/Jodhpuri/.test(v) && /Jodhpuri/.test(NOUN)) ? v + ' ' + NOUN : v;
      h += '<li' + (sel.t[v] ? ' class="active"' : '') + '><button type="button" class="smf-tchip" data-t="' + esc(v) + '">' + esc(lab) + ' <span>' + (cnt[v] || 0) + '</span></button></li>';
    });
    tchips.innerHTML = h; tchips.setAttribute('aria-label', 'Shop by type'); chipsReady();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.smf-tchip');
    if (!b) return;
    var v = b.getAttribute('data-t');
    if (!v || sel.t[v]) sel.t = {}; else { sel.t = {}; sel.t[v] = 1; }
    update();
    var g = document.querySelector('.smf-resbar') || grid; window.scrollTo({ top: g.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
  });
  function renderGrid() {
    if (!loaded) {
      grid.innerHTML = origHTML; grid.classList.remove('smf-filtered');
      if (pagWrap) pagWrap.style.display = '';
      bar.style.display = 'none';
      more.style.display = 'none';
      return;
    }
    var r = results();
    grid.classList.add('smf-filtered');
    if (pagWrap) pagWrap.style.display = 'none';
    grid.innerHTML = r.length ? r.slice(0, shown).map(card).join('') : '<div class="col-12 smf-empty">No products match these filters. <button type="button" data-clear="1">Clear filters</button></div>';
    bar.style.display = '';
    bar.innerHTML = '<span>' + r.length + ' product' + (r.length === 1 ? '' : 's') + '</span>' + chipsHTML();
    more.style.display = r.length > shown ? '' : 'none';
    more.textContent = 'Show more (' + (r.length - shown) + ' left)';
    try { if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') window.bucksCC.reConvert(); } catch (e) {}
  }
  function chipsHTML() {
    var h = '';
    for (var g in sel) for (var v in sel[g]) h += '<button type="button" class="smf-chip-x" data-g="' + g + '" data-v="' + esc(v) + '">' + esc(v) + ' ×</button>';
    if (h) h += '<button type="button" class="smf-chip-x smf-chip-x--all" data-clear="1">Clear all</button>';
    return h;
  }
  function saveURL() {
    try {
      var u = new URL(location.href);
      ['t', 'l', 'c', 'h', 's', 'o', 'p'].forEach(function (g) { var k = Object.keys(sel[g]); if (k.length) u.searchParams.set('f_' + g, k.join('|')); else u.searchParams.delete('f_' + g); });
      if (sort !== 'featured') u.searchParams.set('f_sort', sort); else u.searchParams.delete('f_sort');
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }
  function readURL() {
    try {
      var u = new URL(location.href);
      ['t', 'l', 'c', 'h', 's', 'o', 'p'].forEach(function (g) { var v = u.searchParams.get('f_' + g); if (v) v.split('|').forEach(function (x) { var L = (GROUPS.filter(function (G) { return G[0] === g; })[0] || [0, 0, []])[2]; for (var i = 0; i < L.length; i++) { if (String(L[i]).toLowerCase() === String(x).toLowerCase()) { sel[g][L[i]] = 1; return; } } }); });
      sort = u.searchParams.get('f_sort') || 'featured';
    } catch (e) {}
  }
  function update() { shown = 24; saveURL(); renderPanels(); renderGrid(); }

  var bar = document.createElement('div'); bar.className = 'smf-resbar'; bar.style.display = 'none';
  grid.parentNode.insertBefore(bar, grid);
  var more = document.createElement('button'); more.type = 'button'; more.className = 'smf-more'; more.style.display = 'none';
  grid.parentNode.insertBefore(more, grid.nextSibling);
  more.addEventListener('click', function () { shown += 24; renderGrid(); });

  var desk = document.createElement('div'); desk.className = 'smf-f smf-f--desk';
  var side = null;
  document.querySelectorAll('.shop-page-content .col-lg-3').forEach(function (c) { if (!side && c.querySelector('.single-sidebar-widget')) side = c; });
  if (side) side.insertBefore(desk, side.firstChild); else grid.parentNode.insertBefore(desk, bar);
  panels.push(desk);

  var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'smf-fbtn';
  btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M7 12h10M10 18h4"/></svg> <span>Filter &amp; Sort</span>';
  grid.parentNode.insertBefore(btn, bar);
  var drawer = document.createElement('div'); drawer.className = 'smf-drawer';
  drawer.innerHTML = '<div class="smf-drawer__bg"></div><div class="smf-drawer__panel"><button type="button" class="smf-drawer__x" aria-label="Close">×</button><div class="smf-f smf-f--mob"></div><button type="button" class="smf-drawer__go">Show results</button></div>';
  document.body.appendChild(drawer);
  panels.push(drawer.querySelector('.smf-f--mob'));
  function openD() { drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeD() { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  btn.addEventListener('click', openD);
  drawer.querySelector('.smf-drawer__bg').addEventListener('click', closeD);
  drawer.querySelector('.smf-drawer__x').addEventListener('click', closeD);
  drawer.querySelector('.smf-drawer__go').addEventListener('click', function () { closeD(); var t = bar.style.display === 'none' ? grid : bar; window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); });
  function updateBtn() {
    var n = 0; for (var g in sel) n += Object.keys(sel[g]).length;
    btn.querySelector('span').textContent = 'Filter & Sort' + (n ? ' (' + n + ')' : '');
    var go = drawer.querySelector('.smf-drawer__go'); if (loaded) go.textContent = 'Show ' + results().length + ' results';
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.id === 'smf-sort') { sort = t.value; update(); return; }
    if (t.matches && t.matches('.smf-f input[type=checkbox]')) {
      var g = t.getAttribute('data-g'), v = t.value;
      if (t.checked) sel[g][v] = 1; else delete sel[g][v];
      update();
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-clear],.smf-chip-x');
    if (!t) return;
    if (t.hasAttribute('data-clear')) { sel = { t: {}, l: {}, c: {}, h: {}, s: {}, o: {}, p: {} }; sort = 'featured'; }
    else { delete sel[t.getAttribute('data-g')][t.getAttribute('data-v')]; }
    update();
  });

  panels.forEach(function (p) { p.innerHTML = '<div class="smf-f__head"><span class="smf-f__title">Filter &amp; Sort</span></div><div class="smf-f__loading">Loading filters…</div>'; });

  function load(page) { return fetch(BASE + (BASE.indexOf('?') > -1 ? '&' : '?') + 'view=smfdata&page=' + page, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  load(1).then(function (d) {
    items = d.items || [];
    var rest = [];
    for (var i = 2; i <= Math.min(d.pages || 1, 8); i++) rest.push(load(i));
    return Promise.all(rest).then(function (arr) { arr.forEach(function (x) { items = items.concat(x.items || []); }); });
  }).then(function () {
    items.forEach(tag);
    GROUPS.forEach(function (G) { items.forEach(function (it) { for (var v in it.f[G[0]]) if (G[2].indexOf(v) < 0) G[2].push(v); }); });
    loaded = true;
    readURL();
    renderPanels();
    renderGrid();
  }).catch(function () {
    panels.forEach(function (p) { p.innerHTML = ''; });
    btn.style.display = 'none'; chipsReady();
  });

  var desc = document.querySelector('#smf-col-desc .collection__description');
  if (desc && desc.scrollHeight > 260) {
    desc.classList.add('smf-collapsed');
    var rb = document.createElement('button'); rb.type = 'button'; rb.className = 'smf-readmore'; rb.textContent = 'Read more';
    desc.parentNode.insertBefore(rb, desc.nextSibling);
    rb.addEventListener('click', function () { var c = desc.classList.toggle('smf-collapsed'); rb.textContent = c ? 'Read more' : 'Read less'; });
  }
})();
